import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=57e541b0&scoped=true&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e541b0",
  null
  
)

export default component.exports